import React from "react";
import { Link } from "react-router-dom";
import {
  IoFootstepsOutline,
  IoStorefrontOutline,
  IoBulbOutline,
  IoHelpCircleOutline,
  IoSearchOutline,
  IoCalendarOutline,
  IoStarOutline,
  IoTrendingUpOutline,
  IoPhonePortraitOutline,
  IoLogInOutline,
  IoHeadsetOutline,
  IoGridOutline,
  IoNewspaperOutline,
  IoPricetagsOutline,
  IoBookOutline,
  IoPeopleOutline,
  IoBriefcaseOutline,
  IoMailOutline,
  IoChevronForwardOutline,
  IoHomeOutline,
  IoShieldCheckmarkOutline,
  IoLockClosedOutline,
  IoCallOutline,
  IoTimeOutline,
  IoTrashOutline,
} from "react-icons/io5";
import "../MarketingPages.css";

const ICONS = {
  steps: IoFootstepsOutline,
  search: IoSearchOutline,
  calendar: IoCalendarOutline,
  star: IoStarOutline,
  growth: IoTrendingUpOutline,
  dashboard: IoPhonePortraitOutline,
  signin: IoLogInOutline,
  support: IoHeadsetOutline,
  grid: IoGridOutline,
  articles: IoNewspaperOutline,
  tags: IoPricetagsOutline,
  book: IoBookOutline,
  clients: IoPeopleOutline,
  owners: IoBriefcaseOutline,
  contact: IoMailOutline,
  shield: IoShieldCheckmarkOutline,
  lock: IoLockClosedOutline,
  people: IoPeopleOutline,
  phone: IoCallOutline,
  clock: IoTimeOutline,
  trash: IoTrashOutline,
};

const PAGE_ICONS = {
  about: IoFootstepsOutline,
  business: IoStorefrontOutline,
  blog: IoBulbOutline,
  faq: IoHelpCircleOutline,
  team: IoPeopleOutline,
  privacy: IoShieldCheckmarkOutline,
  support: IoHeadsetOutline,
  contact: IoMailOutline,
  delete: IoTrashOutline,
};

export default function MarketingPageIntro({
  variant,
  page,
  lang,
  layout = "hero",
}) {
  const PageIcon = PAGE_ICONS[variant];
  const homeLabel = lang === "ar" ? "الرئيسية" : "Home";
  const isSplit = layout === "split";
  const stripLayout = layout === "strip" || isSplit;
  const titleId = `page-intro-title-${variant}`;
  const bannerTitle = page.bannerTitle || page.title;
  const bannerIntro = page.bannerIntro || page.intro;

  return (
    <>
      {isSplit && (
        <section
          className={`marketing-top-banner marketing-top-banner--${variant}${lang === "ar" ? " rtl" : ""}`}
          aria-labelledby={`${titleId}-banner`}
        >
          <div className="container">
            <h1 id={`${titleId}-banner`}>{bannerTitle}</h1>
            <p>{bannerIntro}</p>
          </div>
        </section>
      )}

      <header
        className={`page-intro page-intro--${variant} page-intro--${stripLayout ? "strip" : layout}${lang === "ar" ? " rtl" : ""}`}
        aria-labelledby={isSplit ? titleId : undefined}
      >
      <div className="container page-intro__inner">
        <nav className="page-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="page-breadcrumb__link">
            <IoHomeOutline aria-hidden="true" />
            <span>{homeLabel}</span>
          </Link>
          <IoChevronForwardOutline className="page-breadcrumb__sep" aria-hidden="true" />
          <span className="page-breadcrumb__current" aria-current="page">
            {page.breadcrumb}
          </span>
        </nav>

        <div className="page-intro__head">
          <div className="page-intro__icon-wrap" aria-hidden="true">
            <PageIcon className="page-intro__icon" />
          </div>
          <div className="page-intro__copy">
            <p className="page-intro__eyebrow">{page.eyebrow}</p>
            <h1 id={titleId} className="page-intro__title">
              {page.title}
            </h1>
            <p className="page-intro__desc">{page.intro}</p>
            {page.cta && (
              <Link to={page.ctaTo} className="page-intro__cta">
                {page.cta}
              </Link>
            )}
          </div>
        </div>

        <div className="page-intro__highlights" aria-labelledby={`page-highlights-${variant}`}>
          <h2 id={`page-highlights-${variant}`} className="page-intro__highlights-label">
            {page.sectionsLabel}
          </h2>
          <ul className="page-highlights-grid">
            {page.highlights.map((item) => {
              const Icon = ICONS[item.icon] || IoBulbOutline;
              return (
                <li key={item.title} className="page-highlight-card">
                  <span className="page-highlight-card__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <div className="page-highlight-card__body">
                    <h3 className="page-highlight-card__title">{item.title}</h3>
                    <p className="page-highlight-card__desc">{item.desc}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </header>
    </>
  );
}
